import { LOCALHOST_ENVIRONMENT } from "common/environment";

// This will remove all subdomains, so "a.b.c.d.hegias.com" will become "hegias.com"
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function getDomain(): string | undefined {
	// if (LOCALHOST_ENVIRONMENT) {
	// 	return undefined;
	// }

	const hostnameArray = window.location.hostname.split(".");
	const numberOfSubdomains = hostnameArray.length - 2;
	const domain =
		hostnameArray.length === 2
			? window.location.hostname
			: hostnameArray.slice(numberOfSubdomains).join(".");

	logger.debug("[AuthProvider] getDomain: ", {
		LOCALHOST_ENVIRONMENT,
		hostname: window.location.hostname,
		domain,
	});

	return domain;
}

// The `domain` for a cookie. On an IP address or a single-label host
// (localhost) there is no parent domain to share the cookie with: getDomain()
// would turn 192.168.0.196 into "0.196", and the browser silently drops a
// cookie set for that, so the login was lost on every reload. undefined makes
// it a host-only cookie, which is what those hosts need.
export function getCookieDomain(): string | undefined {
	const { hostname } = window.location;
	const isIpAddress =
		/^\d{1,3}(\.\d{1,3}){3}$/.test(hostname) || hostname.includes(":");

	if (isIpAddress || !hostname.includes(".")) {
		return undefined;
	}

	return getDomain();
}
